import React from 'react';
import PropTypes from 'prop-types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import utils from 'helpers/utils';
import translate from 'components/hoc/translate';

class AutoCompleteData extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            choices: [],
            error: '',
            loading: false,
            presetValue: false,
        };
    }

    componentDidMount() {
        const {
            input: {
                value,
            },
        } = this.props;

        if (value) {
            this.setState({
                presetValue: true,
            }, () => {
                this.fetchData({
                    id: [
                        value,
                    ],
                });
            });
        }
    }

    componentDidUpdate(prevProps) {
        const inputValue = this.props.input.value;
        const nextValue = prevProps.input.value;

        const {
            presetValue,
        } = this.state;

        if (!presetValue && inputValue !== nextValue) {
            this.fetchData({
                id: [
                    inputValue,
                ],
            });

            this.setState({
                presetValue: true,
            });
        }
    }

    fetchData = (params) => {
        params = params || {};

        this.setLoading(true);

        const {
            reference,
            searchParams,
            translate,
        } = this.props;

        let newParams = Object.assign({}, params, searchParams);

        const url = `${ config.getApiBaseUrl() }/${ reference }`;

        return apiClient.read(url, newParams).then((response) => {
            let error;

            if (utils.isEmpty(response.results)) {
                error = translate('general.noMatches');
            }

            setTimeout(() => {
                this.setLoading(false);

                this.setState({
                    choices: response.results,
                    error: error,
                });
            }, 2000);
        }, (error) => {
            setTimeout(() => {
                this.setLoading(false);

                this.setState({
                    error: error.response.message,
                });
            }, 2000);

            return;
        });
    }

    setLoading = (loading) => {
        this.setState({
            loading: loading,
        });
    }

    handleInputUpdate = utils.debounce((searchText, dataSource, params) => {
        const {
            minLength,
            searchBy,
        } = this.props;

        // If the string of the source is not 'change' it will not continue.
        if (params.source !== 'change') {
            return;
        }

        // Remove whitespaces around the text.
        if (utils.isString(searchText)) {
            searchText.trim();
        }

        // Remove whitespaces around the text.
        if (searchText.length < minLength) {
            return this.setState({
                choices: [],
                loading: false,
                error: '',
            });
        }

        // Check if the searchText already exists in the dataSource.
        const textExists = dataSource.filter(function (data) {
            return data.text === searchText;
        });

        // If the length of the array > 0, it will not continue.
        if (textExists.length) {
            return;
        }

        this.fetchData({
            [searchBy]: `*${ searchText }*`,
        });
    }, 500);

    render() {
        const {
            children,
        } = this.props;

        const {
            choices,
            loading,
            error,
        } = this.state;

        return (
            <span>
                { React.cloneElement(children, {
                    choices: choices,
                    error: error,
                    handleInitData: this.handleInitData,
                    loading: loading,
                    onInputUpdate: this.handleInputUpdate,
                }) }
            </span>
        );
    }
}

AutoCompleteData.defaultProps = {
    offset: 0,
    size: 12,
    sort: {
        field: 'id',
        order: 'asc',
    },
};

AutoCompleteData.propTypes = {
    children: PropTypes.element,
    input: PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    }).isRequired,
    minLength: PropTypes.number.isRequired,
    reference: PropTypes.string.isRequired,
    searchBy: PropTypes.string.isRequired,
    searchParams: PropTypes.object,
    sort: PropTypes.shape({
        field: PropTypes.string,
        order: PropTypes.string,
    }).isRequired,
    translate: PropTypes.func,
};

export default translate(AutoCompleteData);



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/autocomplete/AutoCompleteData.js